<template>
  <v-layout row wrap justify-center align-center>
    <v-flex xs12 sm10 md8 lg6 class="text-xs-center mx-3 mb-3">
      <v-card>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card-text class="note-withdraw">
            <v-card class="pa-2">
              <v-select
                v-model="rider_selected"
                :items="rider_wallet"
                item-text="wallet_name"
                item-value="wallet_rider_id"
                label="Rider name"
                @change="selectRider($event)"
                :disabled="
                  action_text == 0 ? isEditRiderMoney : isEditRiderMoneyRefill
                "
                :rules="[rules.required]"
              ></v-select>
              <v-layout row wrap class="text-xs-center" style="color: #d6d6d6">
                <v-flex xs6>
                  <span class="style-title-detail">Cash :</span>
                  <span class="style-data-detail">{{ rider_cash }} ฿</span>
                </v-flex>
                <v-flex xs6>
                  <span class="style-title-detail">Credit :</span>
                  <span class="style-data-detail">{{ rider_credit }}</span>
                </v-flex>
              </v-layout>
            </v-card>
            <v-text-field
              :label="
                action_text == 0 ? 'Amount to withdraw' : 'Amount to refill'
              "
              v-model="cash_withdraw"
              type="number"
              :rules="[rules.required]"
              :disabled="
                action_text == 0 ? isEditRiderMoney : isEditRiderMoneyRefill
              "
            ></v-text-field>
            <v-text-field
              v-model="order_code"
              :disabled="
                action_text == 0 ? isEditRiderMoney : isEditRiderMoneyRefill
              "
              v-if="action_text != 0"
              label="Ref.Order code"
              placeholder="WE123XX45678"
              mask="AANNNNNNNNNN"
              :rules="[rules.equal]"
            ></v-text-field>
            <v-select
              :disabled="
                action_text == 0 ? isEditRiderMoney : isEditRiderMoneyRefill
              "
              v-if="action_text != 0"
              v-model="remark"
              item-value="transport_zone_name_th"
              item-text="transport_zone_name_th"
              :items="zone_list"
              label="Remark zone"
              hide-details
            ></v-select>
            <v-textarea
              :disabled="
                action_text == 0 ? isEditRiderMoney : isEditRiderMoneyRefill
              "
              v-model="note"
              v-if="action_text != 0"
              label="Note"
              hide-details
              rows="2"
            ></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="primary"
              class="black--text"
              :disabled="
                cash_withdraw > rider_cash ||
                cash_withdraw <= 0 ||
                isLoading == true ||
                (action_text == 0 ? isEditRiderMoney : isEditRiderMoneyRefill)
              "
              @click="Submit()"
              v-if="action_text == 0"
              >submit</v-btn
            >
            <v-btn
              color="primary"
              class="black--text"
              @click="Submit()"
              :disabled="
                isLoading == true ||
                (action_text == 0 ? isEditRiderMoney : isEditRiderMoneyRefill)
              "
              v-else
              >submit</v-btn
            >
            <v-spacer />
            <div v-if="isLoading == false && success_status != 0">
              <v-icon :color="success_status == 1 ? 'green' : 'red'">{{
                success_status == 1 ? "check" : "close"
              }}</v-icon>
              {{ success_status == 1 ? "Successfully" : "Cant" }}
            </div>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-flex>
    <v-flex
      xs12
      sm10
      md8
      class="text-xs-center mx-3 mb-3"
      v-if="action_text == 0"
    >
      <v-card color="secondary">
        <v-card-text class="note-withdraw">
          เมนู "Withdraw Cash" ใช้สำหรับการส่งคำร้องเพื่อขอถอนเงิน (cash) ของ
          rider ออกจากระบบ เมื่อส่งคำร้องเรียบร้อยแล้ว สามารถอนุมัติได้ในเมนู
          "Money > Request cash"
          <div class="red--text">
            หมายเหตุ : การถอนเงินมีการคิดค่าธรรมเนียมในการโอนเงิน
            สามารถแก้ไขได้ในเมนู "Setting > General"
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  props: {
    action_text: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  data() {
    return {
      note: null,
      order_code: "",
      remark: null,
      success_status: 0,
      rider_wallet: [],
      isLoading: false,
      rider_selected: {},
      rider_cash: 0,
      rider_credit: 0,
      rider_id: null,
      cash_withdraw: null,
      zone_list: [],
      valid: true,
      rules: {
        required: (value) => !!value || "Required.",
        equal: (value) =>
          value.length == 0 ||
          value.length == 12 ||
          "Ref.order code is 12 characters",
      },
    };
  },
  computed: {
    ...mapState({
      permission: (state) => state.permission,
    }),
    isEditRiderMoney() {
      // rider_refill: 2;
      if (!this.permission.rider.rider_money.rider_withdraw) {
        return true;
      }
      return this.permission.rider.rider_money.rider_withdraw == 1
        ? true
        : false;
    },
    isEditRiderMoneyRefill() {
      if (!this.permission.rider.rider_money.rider_refill) {
        return true;
      }
      return this.permission.rider.rider_money.rider_refill == 1 ? true : false;
    },
  },
  async created() {
    this.rider_wallet = await this.$store.dispatch(
      "fetchCashRider/getRiderWallet"
    );
    this.zone_list = await this.$store.dispatch(
      "fetchFoodZoneBack/getTransferZoneList"
    );
  },
  methods: {
    selectRider(item) {
      for (var i = 0; i < this.rider_wallet.length; i++) {
        if (this.rider_wallet[i].wallet_rider_id == item) {
          this.rider_cash = this.rider_wallet[i].wallet_cash;
          this.rider_credit = this.rider_wallet[i].wallet_credit;
          this.rider_id = item;
          break;
        }
      }
    },
    async Submit() {
      if (this.$refs.form.validate()) {
        let check = null;
        this.isLoading = true;
        if (this.action_text == 0) {
          let sendData = {
            money: this.cash_withdraw,
            rider_id: this.rider_id,
          };
          check = await this.$store.dispatch(
            "fetchCashRider/postWithdrawCash",
            sendData
          );
        } else if (this.action_text == 1) {
          let sendData = {
            money: this.cash_withdraw,
            rider_id: this.rider_id,
            order_code: this.order_code,
            remark: this.remark,
            note: this.note,
          };
          check = await this.$store.dispatch(
            "fetchCashRider/RefillCredit",
            sendData
          );
        }
        this.isLoading = false;
        if (check == true) {
          this.note = null;
          this.order_code = null;
          this.remark = null;
          this.rider_selected = {};
          this.rider_cash = 0;
          this.rider_credit = 0;
          this.rider_id = null;
          this.cash_withdraw = null;
          this.rider_wallet = [];
          await this.$store.dispatch("fetchCashRider/getRefillCredit");
          this.rider_wallet = await this.$store.dispatch(
            "fetchCashRider/getRiderWallet"
          );
          this.success_status = 1;
        } else {
          this.success_status = -1;
        }
      }
    },
  },
};
</script>

<style scoped>
.note-withdraw {
  font-size: 15px;
}

.style-title-detail {
  font-size: 15px;
  margin-bottom: 10px;
}

.style-data-detail {
  font-size: 15px;
  color: #d6d6d6;
}
</style>

<style>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
